import { render } from "./BlogHolidayGiftGuideView.vue?vue&type=template&id=5b901ddc"
import script from "./BlogHolidayGiftGuideView.vue?vue&type=script&lang=js"
export * from "./BlogHolidayGiftGuideView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__